import { Suspense, useEffect } from "react"
import { Router } from "@/features/router/Router"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { ToastContainer } from "@/components/ToastContainer"
import { Loading } from "@/components/ui/loading"
import { useInitializeApp } from "@/hooks/useInitializeApp"
import { SidebarProvider } from "@/components/providers/sidebar-provider"
import useViewportScale from "@/hooks/useViewportScale"
import ViewportScaleDebugger from "@/components/ViewportScaleDebugger"

export default function App() {
  useInitializeApp()
  useViewportScale() // Hook para gerenciar escala via viewport

  useEffect(() => {
    document.documentElement.classList.add('dark')
  }, [])

  return (
    <ErrorBoundary>
      <SidebarProvider>
        <Suspense fallback={<Loading />}>
          <Router />
          <ToastContainer />
        </Suspense>
      </SidebarProvider>
      <ViewportScaleDebugger enabled={import.meta.env.DEV} />
    </ErrorBoundary>
  )
} 